module.exports = __webpack_public_path__ + "img/07.a09dc635.png";